export default "__VITE_ASSET__h5P_BJZz__"